module.exports = __webpack_public_path__ + "img/tubogalvanizado.d1203180.jpg";